import React, { Fragment } from 'react';
import { Input, Icon, Dropdown, Menu, Button } from 'antd';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import classNames from 'classnames/bind';
import { setSearchKey, setSearchMethod, fetchResultFromRemote } from 'views/GlobalSearch/flow/action';
import deleteIcon from 'assets/images/icon-delete.svg';
import styles from '../TopPanel.less';

const cx = classNames.bind(styles);
const { SearchMethodKeys } = Enums;
const { Fuzzy, Phrase } = SearchMethodKeys;

class SearchInput extends React.Component {
  onSearch = () => {
    const {
      searchKey,
      searchMethod,
      setSearchKey,
      history,
      fetchResultFromRemote
    } = this.props;
    setSearchKey(searchKey);
    history.push('/globalSearch');
    const method = searchMethod === Phrase ? '1' : '0';
    fetchResultFromRemote(searchKey, method);
  }

  render() {
    const {
      intl,
      searchKey,
      searchMethod,
      setSearchKey,
      setSearchMethod
    } = this.props;
    const { formatMessage } = intl;
    const searchIcon = (
      !_.isEmpty(searchKey) ?
        <img src={deleteIcon} alt="delete" className="cursor-pointer" onClick={() => setSearchKey('')} /> :
        <Icon type="search" />
    );

    const menu = (
      <Menu
        className="toppannel-dropdown"
        onClick={({ key }) => setSearchMethod(key)}
        selectedKeys={[searchMethod]}
      >
        <Menu.Item key={Fuzzy}>
          {formatMessage({ id: 'page.topPanel.search.fuzzy' })}
        </Menu.Item>
        <Menu.Item key={Phrase}>
          {formatMessage({ id: 'page.topPanel.search.phrase' })}
        </Menu.Item>
      </Menu>
    );

    return (
      <Fragment>
        <Input
          value={searchKey}
          onChange={e => setSearchKey(e.target.value)}
          onPressEnter={this.onSearch}
          className={classNames('search-input')}
          placeholder={formatMessage({ id: 'global.ui.button.search' })}
          style={{ width: 200, marginTop: 7, float: 'right' }}
          suffix={searchIcon}
        />
        <Dropdown overlay={menu} trigger={['click']}>
          <Button className="topNav-search-dropdown">
            {formatMessage({ id: `page.topPanel.search.${searchMethod}` })}
            <Icon type="down" style={{ float: 'right', lineHeight: '1.5' }} />
          </Button>
        </Dropdown>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ global, globalSearch }) => ({
  language: global.language,
  searchKey: globalSearch.globalSearchKey,
  searchMethod: globalSearch.globalSearchMethod,
});
const mapDispatchToProp = {
  setSearchKey,
  setSearchMethod,
  fetchResultFromRemote
};


export default compose(
  connect(mapStateToProps, mapDispatchToProp),
  withRouter,
  injectIntl
)(SearchInput);



// WEBPACK FOOTER //
// ./src/components/page/TopPanel/component/SearchInput.jsx